import { render, staticRenderFns } from "./sopChecklist.vue?vue&type=template&id=0fa24fe4&"
import script from "./sopChecklist.vue?vue&type=script&lang=js&"
export * from "./sopChecklist.vue?vue&type=script&lang=js&"
import style0 from "./sopChecklist.vue?vue&type=style&index=0&id=0fa24fe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports